var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-login",
    class: {
      onn: _vm.scrollPosition > 41
    }
  }, [(_vm.blockUi) ? _c('BlockUI', {
    attrs: {
      "message": _vm.msg,
      "url": _vm.url
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "id": "topnav"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row align-items-center py-2"
  }, [(_vm.instanceName !== 'MAHADEMY') ? _c('div', {
    staticClass: "col-md-8 offers"
  }, [(_vm.checkOffer()) ? _c('div', [(_vm.$store.getters.getOffers !== undefined && _vm.$store.getters.getOffers !== null && _vm.$store.getters.getOffers.length == 1) ? _c('div', [_c('a', [_vm._v("\n                " + _vm._s(_vm.$store.getters.getOffers[0].offerTitle) + " "), _c('strong', [_vm._v("OFFER CODE : ")]), _vm._v(" " + _vm._s(_vm.$store.getters.getOffers[0].offerCode) + "\n              ")])]) : _c('div', [_c('b', [_c('span', [_vm._v(_vm._s(_vm.$t('offers.new_offers_available_soon')))])])])]) : _c('div', [_c('b', [_c('span', [_vm._v(_vm._s(_vm.$t('offers.new_offers_available_soon')))])])])]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn !== undefined && _vm.isLoggedIn !== null && _vm.isLoggedIn) ? _c('div', {
    staticClass: "col-md-4 user-links ml-auto"
  }, [_c('span', {
    staticClass: "nav-t"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'myCourses'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.MyCourses')))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'playlist'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('playlist.labels.MyPlaylist')))]) : _vm._e(), _vm._v(" "), (_vm.isMobileDevice()) ? _c('b-btn', {
    staticClass: "router-link",
    on: {
      "click": _vm.goOffline
    }
  }, [_vm._v("Go Offline")]) : _vm._e()], 1)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main-header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "lg"
    }
  }, [_c('div', {
    staticClass: "row no-gutters align-items-center"
  }, [(_vm.instanceName === 'mfslivedemy') ? _c('div', {
    staticClass: "col col-lg-3 mfs-logo"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/mfs-logo.png",
      "alt": "mfslivedemy"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.instanceName === 'MAHADEMY') ? _c('div', {
    staticClass: "col col-lg-3 maha-demy"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/mahademylogo.png",
      "alt": "MAHADEMY"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.instanceName === 'LIVEDEMY') ? _c('div', {
    staticClass: "col col-lg-3"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/livedemy-logo-1.png",
      "alt": "LIVEDEMY"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-100 d-block d-md-none"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-collapse"
  }, [_c('b-collapse', {
    staticClass: "justify-content-center",
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [(_vm.checkNavStatus()) ? _c('div', {
    staticClass: "m-links-holder"
  }, [_c('div', {
    staticClass: "menu-links"
  }, [_c('span', {
    class: _vm.$store.getters.getSearchType === 'all' ? 'active' : 'inActive',
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        _vm.goToSearchPage('allBtn')
      },
      "focus": function($event) {
        _vm.goToSearchPage('allBtn')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.All')))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('span', {
    class: _vm.$store.getters.getSearchType === 'CO' ? 'active' : 'inActive',
    attrs: {
      "tabindex": "2"
    },
    on: {
      "click": function($event) {
        _vm.goToSearchPage('courseBtn')
      },
      "focus": function($event) {
        _vm.goToSearchPage('courseBtn')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.check_courses')))]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('span', {
    class: _vm.$store.getters.getSearchType === 'LO' ? 'active' : 'inActive',
    attrs: {
      "tabindex": "3"
    },
    on: {
      "click": function($event) {
        _vm.goToSearchPage('libraryBtn')
      },
      "focus": function($event) {
        _vm.goToSearchPage('libraryBtn')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.surf_library')))]) : _vm._e()])]) : _c('div', {
    staticClass: "m-search-holder"
  }, [_c('Autocomplete', {
    ref: "txt_search",
    attrs: {
      "resetAfter": false,
      "openDirection": "bottom",
      "searchable": true,
      "value": _vm.searchText,
      "preserveSearch": true,
      "selectLabel": "Search",
      "deselectLabel": "Search",
      "selectedLabel": "Search",
      "tag-placeholder": "Search",
      "taggable": true,
      "optionsLimit": 5,
      "placeholder": _vm.$t('common.labels.SearchPlaceHolder'),
      "options": _vm.suggestions,
      "id": "example-text-input"
    },
    on: {
      "tag": _vm.addTag,
      "search-change": _vm.getSuggestions,
      "select": _vm.onSearch,
      "remove": _vm.onSearch
    }
  }), _vm._v(" "), (_vm.loading !== undefined && _vm.loading !== null && _vm.loading && !_vm.checkNavStatus()) ? _c('div', {
    staticClass: "ms-loader"
  }, [_c('div', {
    staticClass: "loader-dr"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('searchPage.labels.loading')))])]) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-lg-3"
  }, [_c('div', {
    staticClass: "h-right"
  }, [(_vm.isLoggedIn) ? _c('div', {
    staticClass: "h-user"
  }, [(_vm.instanceName !== 'MAHADEMY') ? _c('div', {
    staticClass: "icons-css"
  }, [(_vm.featureList && _vm.featureList.wishlist) ? _c('router-link', {
    staticClass: "wishlist  d-xs3-block",
    attrs: {
      "to": {
        name: 'wishList'
      },
      "tabindex": "4"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-heart",
    attrs: {
      "title": "Wishlist",
      "aria-hidden": "true"
    }
  }), _c('span', {
    class: _vm.$store.getters.getWishListStoreData != undefined && _vm.$store.getters.getWishListStoreData != null && _vm.$store.getters.getWishListStoreData.length > 0 ? 'count' : ''
  }, [_vm._v(_vm._s(_vm.$store.getters.getWishListStoreData != undefined && _vm.$store.getters.getWishListStoreData != null && _vm.$store.getters.getWishListStoreData.length > 0 ? _vm.$store.getters.getWishListStoreData.length : ""))])]) : _vm._e(), _vm._v(" "), (_vm.featureList && _vm.featureList.cart) ? _c('router-link', {
    staticClass: "cart",
    attrs: {
      "to": {
        name: 'cart'
      },
      "tabindex": "5"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-cart",
    attrs: {
      "title": "Cart",
      "aria-hidden": "true"
    }
  }), _c('span', {
    class: _vm.$store.getters.getCartData.items != undefined && _vm.$store.getters.getCartData.items != null && _vm.$store.getters.getCartData.items.length > 0 ? 'count' : ''
  }, [_vm._v(_vm._s(_vm.$store.getters.getCartData.items != undefined && _vm.$store.getters.getCartData.items != null && _vm.$store.getters.getCartData.items.length > 0 ? _vm.$store.getters.getCartData.items.length : ""))])]) : _vm._e(), _vm._v(" "), (_vm.featureList && _vm.featureList.wallet) ? _c('router-link', {
    staticClass: "wallet  d-xs3-block",
    attrs: {
      "to": {
        name: 'wallet'
      },
      "tabindex": "6"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-wallet",
    attrs: {
      "title": "Wallet",
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-user"
  }, [_c('b-dropdown', {
    attrs: {
      "variant": "link",
      "right": "",
      "no-caret": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [(_vm.basicProfile.profileImg != '') ? _c('img', {
    attrs: {
      "src": _vm.basicProfile.profileImg
    }
  }) : _vm._e(), _vm._v(" "), (_vm.basicProfile.profileImg == '') ? _c('img', {
    attrs: {
      "src": "static/assets/images/user.png"
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "mdi mdi-chevron-down"
  })]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'profile'
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-account-box-outline"
  }), _vm._v(" " + _vm._s(_vm.$t('common.labels.your_profile')))]), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-power"
  }), _vm._v(" " + _vm._s(_vm.$t('common.labels.logout')))]) : _vm._e(), _vm._v(" "), (_vm.instanceName == 'MAHADEMY') ? _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exitFromMahademy($event)
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-power"
  }), _vm._v(" " + _vm._s(_vm.$t('common.labels.Back')))]) : _vm._e()], 2)], 1)]) : _c('div', {
    staticClass: "h-links"
  }, [(!_vm.isMobileDevice()) ? _c('b-link', {
    on: {
      "click": function () {
        _vm.reset()
        _vm.isLoginWithInvalidCredentials = false
        this$1.$refs.loginModal.show()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.log_in')) + "\n                ")]) : _c('b-link', {
    on: {
      "click": _vm.sendtoMobileLogin
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.log_in')) + "\n                ")]), _vm._v(" "), (_vm.featureList != null && _vm.featureList != undefined && _vm.featureList.signUp !== null && _vm.featureList.signUp !== undefined && _vm.featureList.signUp) ? _c('b-link', {
    on: {
      "click": function () {
        _vm.resetPasswordPolicyFlags()
        _vm.reset()
        this$1.$refs.signupModal.show()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.labels.sign_up')) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-navbar-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "loginModal",
    staticClass: "text-left",
    attrs: {
      "id": "login",
      "hide-footer": "",
      "title": "Welcome back !"
    },
    on: {
      "shown": _vm.focusOnLoginModal
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [(_vm.isLoginWithInvalidCredentials) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("Invalid login details !")]) : _vm._e(), (_vm.isLoginWithInvalidCredentials) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Email / Mobile no")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    ref: "username",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter email / mobile no",
      "aria-describedby": "username",
      "id": "username",
      "tabindex": "7"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emptyUsername && _vm.username.length === 0),
      expression: "emptyUsername && username.length === 0"
    }],
    staticClass: "w-100 text-danger"
  }, [_c('small', [_vm._v("Username cannot be empty")])])]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "password"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })]), _vm._v(" "), (_vm.togglePasswordInputType) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control with-icon",
    attrs: {
      "type": "password",
      "placeholder": "Enter password",
      "aria-describedby": "password",
      "tabindex": "8"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleLogin($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control with-icon",
    attrs: {
      "type": "text",
      "placeholder": "Enter password",
      "aria-describedby": "password",
      "tabindex": "8"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleLogin($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emptyPassword && _vm.password.length === 0),
      expression: "emptyPassword && password.length === 0"
    }],
    staticClass: "w-100 text-danger"
  }, [_c('small', [_vm._v("Password cannot be empty")])]), _vm._v(" "), (_vm.togglePasswordInputType) ? _c('span', {
    staticClass: "input-icon mdi mdi-eye",
    on: {
      "click": function () {
        _vm.togglePasswordInputType = false
      }
    }
  }) : _c('span', {
    staticClass: "input-icon mdi mdi-eye-off",
    on: {
      "click": function () {
        _vm.togglePasswordInputType = true
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "forgotpwd d-flex"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function () {
        _vm.resetPasswordPolicyFlags()
        _vm.reset()
        this$1.$refs.forgetPasswordModal.show()
      }
    }
  }, [_vm._v("Forgot Password?")])])]), _vm._v(" "), _c('b-btn', {
    staticClass: "btn-large login-btn",
    attrs: {
      "block": "",
      "variant": "outline-danger",
      "tabindex": "6"
    },
    on: {
      "click": _vm.handleLogin,
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleLogin($event)
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), (_vm.featureList != null && _vm.featureList != undefined && _vm.featureList.signUp !== null && _vm.featureList.signUp !== undefined && _vm.featureList.signUp) ? _c('div', {
    staticClass: "d-flex justify-content-center sub-title newuser",
    on: {
      "click": function () {
        _vm.reset()
        _vm.resetPasswordPolicyFlags()
        this$1.$refs.signupModal.show()
      }
    }
  }, [_vm._v("New User?  "), _c('a', {
    attrs: {
      "href": "#",
      "tabindex": "7"
    }
  }, [_vm._v("Sign Up")])]) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    ref: "signupModal",
    staticClass: "text-left",
    attrs: {
      "id": "signup",
      "hide-footer": "",
      "title": "Sign up and start learning now!"
    },
    on: {
      "shown": _vm.focusOnSignUpModal
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Full Name")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "fullname"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /^[a-zA-Z ]*$/
        }
      }),
      expression: "{rules:{required: true, regex: /^[a-zA-Z ]*$/}}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.fullname),
      expression: "fullname"
    }],
    ref: "fullName",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter your full name",
      "aria-describedby": "fullname",
      "name": "fullname",
      "autofocus": "",
      "tabindex": "8"
    },
    domProps: {
      "value": (_vm.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fullname')),
      expression: "errors.has('fullname')"
    }],
    staticClass: "w-100 text-danger"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.first('fullname')))])])]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(_vm.emailAlreadyInUse) ? _c('span', {
    staticClass: "w-100 text-danger"
  }, [_vm._v("Email id already in use")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Your email ID",
      "aria-describedby": "email",
      "tabindex": "9"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email') && _vm.email.length != 0),
      expression: "errors.has('email') && email.length != 0"
    }],
    staticClass: "w-100 text-danger"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.first('email')))])])]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(_vm.mobileAlreadyInUse) ? _c('span', {
    staticClass: "w-100 text-danger"
  }, [_vm._v("Mobile number already in use")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "mobile"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|length:10'),
      expression: "'required|numeric|length:10'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mobile number",
      "placeholder": "Enter mobile",
      "aria-describedby": "mobile",
      "tabindex": "10"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mobile number') && _vm.mobile.length != 0),
      expression: "errors.has('mobile number') && mobile.length != 0"
    }],
    staticClass: "w-100 text-danger"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.first('mobile number')))])])]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "password"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })]), _vm._v(" "), (_vm.togglePasswordInputType) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control with-icon",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Enter password",
      "aria-describedby": "password",
      "tabindex": "11"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleRegistration()
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        _vm.validatePasswordInput(_vm.password)
      }]
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control with-icon",
    attrs: {
      "name": "password",
      "type": "text",
      "placeholder": "Enter password",
      "aria-describedby": "password",
      "tabindex": "11"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleRegistration()
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        _vm.validatePasswordInput(_vm.password)
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password') && _vm.password.length != 0),
      expression: "errors.has('password') && password.length != 0"
    }],
    staticClass: "w-100 text-danger"
  }, [_c('small', [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), (_vm.togglePasswordInputType) ? _c('span', {
    staticClass: "input-icon mdi mdi-eye",
    on: {
      "click": function () {
        _vm.togglePasswordInputType = false
      }
    }
  }) : _c('span', {
    staticClass: "input-icon mdi mdi-eye-off",
    on: {
      "click": function () {
        _vm.togglePasswordInputType = true
      }
    }
  })]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Password must have: ")]), _vm._v(" "), _c('ul', [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.strike_cap_alpha),
      expression: "!strike_cap_alpha"
    }]
  }, [_vm._v(" At least 1 capital alphabet ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.strike_cap_alpha),
      expression: "strike_cap_alpha"
    }],
    staticClass: "strikethrough"
  }, [_vm._v(" At least 1 capital alphabet ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.strike_length),
      expression: "!strike_length"
    }]
  }, [_vm._v(" At least 4 characters ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.strike_length),
      expression: "strike_length"
    }],
    staticClass: "strikethrough"
  }, [_vm._v(" At least 4 characters ")])])])]), _vm._v(" "), _c('b-btn', {
    staticClass: "btn-large col-12 login-btn",
    attrs: {
      "variant": "outline-danger",
      "tabindex": "12"
    },
    on: {
      "click": function($event) {
        _vm.handleRegistration()
      }
    }
  }, [_vm._v("Sign Up")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center sub-title newuser",
    on: {
      "click": function () {
        _vm.reset()
        this$1.$refs.loginModal.show()
      }
    }
  }, [_vm._v("Already have an account?  "), _c('a', {
    attrs: {
      "href": "#",
      "tabindex": "13"
    }
  }, [_vm._v("Login")])])], 1), _vm._v(" "), _c('b-modal', {
    ref: "forgetPasswordModal",
    staticClass: "text-left",
    attrs: {
      "id": "forgetPassword",
      "hide-footer": "",
      "title": "Forgot Password?"
    },
    on: {
      "shown": _vm.focusOnForgetPasswordModal
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [(!_vm.isOtpRequestSend) ? _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Email / mobile no")]) : _vm._e(), _vm._v(" "), (!_vm.isOtpRequestSend) ? _c('div', {
    staticClass: "input-group"
  }, [(_vm.invalidUsernameOtp) ? _c('span', {
    staticClass: "w-100 text-danger"
  }, [_vm._v(" Invalid details entered")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "name"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    ref: "usernameForgotInput",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter email / mobile no",
      "aria-describedby": "text",
      "tabindex": "14",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isOtpRequestSend) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.isOtpRequestSend) ? _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Enter OTP")]) : _vm._e(), _vm._v(" "), (_vm.isOtpRequestSend) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.otpInput),
      expression: "otpInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter OTP",
      "aria-describedby": "email",
      "tabindex": "18",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.otpInput)
    },
    on: {
      "keyup": function($event) {
        _vm.validateForNumberInput(_vm.otpInput, false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otpInput = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.invalidOtp) ? _c('small', {
    staticClass: "w-100 text-danger"
  }, [_vm._v("Oops! The OTP you've entered is invalid, try entering it again, else click on resend OTP link below")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "tabindex": "15"
    }
  }, [(_vm.isOtpRequestSend) ? _c('b-link', {
    staticClass: "w-100 resend-otp",
    on: {
      "click": function($event) {
        _vm.handleOtpResend()
      }
    }
  }, [_vm._v("Resend OTP")]) : _vm._e()], 1), _vm._v(" "), (!_vm.isOtpRequestSend) ? _c('b-form-group', [_c('b-form-checkbox-group', {
    ref: "otpcheckRef",
    attrs: {
      "id": "otpcheck",
      "name": "",
      "options": _vm.optOnMail
    },
    model: {
      value: (_vm.otpOptions),
      callback: function($$v) {
        _vm.otpOptions = $$v
      },
      expression: "otpOptions"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isOtpRequestSend) ? _c('b-btn', {
    staticClass: "btn-large login-btn",
    attrs: {
      "block": "",
      "variant": "outline-danger",
      "tabindex": "17"
    },
    on: {
      "click": _vm.handleOtpRequest
    }
  }, [_vm._v("Send OTP")]) : _vm._e(), _vm._v(" "), (_vm.isOtpRequestSend) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.isOtpRequestSend) ? _c('b-btn', {
    staticClass: "btn-large login-btn",
    attrs: {
      "block": "",
      "variant": "outline-danger",
      "tabindex": "19"
    },
    on: {
      "click": _vm.handleOtpVerification
    }
  }, [_vm._v("Verify OTP")]) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    ref: "passwordChangeModal",
    staticClass: "text-left",
    attrs: {
      "id": "passwordChange",
      "hide-footer": "",
      "title": "Change password"
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("New password")]), _vm._v(" "), (_vm.passwordMismatch) ? _c('span', {
    staticClass: "w-100 text-danger"
  }, [_vm._v("Password doesn't match")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "name"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), (_vm.togglePasswordInputType) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "newPasswordInputField",
    staticClass: "form-control with-icon",
    attrs: {
      "type": "password",
      "placeholder": "Enter new password",
      "aria-describedby": "text",
      "tabindex": "20"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        _vm.validatePasswordInput(_vm.password)
      }]
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "newPasswordInputField",
    staticClass: "form-control with-icon",
    attrs: {
      "type": "text",
      "placeholder": "Enter new password",
      "aria-describedby": "text",
      "tabindex": "20"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        _vm.validatePasswordInput(_vm.password)
      }]
    }
  }), _vm._v(" "), (_vm.togglePasswordInputType) ? _c('span', {
    staticClass: "input-icon mdi mdi-eye",
    on: {
      "click": function () {
        _vm.togglePasswordInputType = false
      }
    }
  }) : _c('span', {
    staticClass: "input-icon mdi mdi-eye-off",
    on: {
      "click": function () {
        _vm.togglePasswordInputType = true
      }
    }
  })]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Password must have: ")]), _vm._v(" "), _c('ul', [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.strike_cap_alpha),
      expression: "!strike_cap_alpha"
    }]
  }, [_vm._v(" At least 1 capital alphabet ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.strike_cap_alpha),
      expression: "strike_cap_alpha"
    }],
    staticClass: "strikethrough"
  }, [_vm._v(" At least 1 capital alphabet ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.strike_length),
      expression: "!strike_length"
    }]
  }, [_vm._v(" At least 4 characters ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.strike_length),
      expression: "strike_length"
    }],
    staticClass: "strikethrough"
  }, [_vm._v(" At least 4 characters ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "name"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Confirm password",
      "aria-describedby": "text",
      "tabindex": "21"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isLinkingOperationPerformed) ? _c('b-btn', {
    staticClass: "btn-large login-btn",
    attrs: {
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCommonPasswordRequest
    }
  }, [_vm._v("Submit")]) : _c('b-btn', {
    staticClass: "btn-large login-btn",
    attrs: {
      "block": "",
      "variant": "outline-danger",
      "tabindex": "22"
    },
    on: {
      "click": _vm.handlePasswordReset
    }
  }, [_vm._v("Change Password")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "mobileNumberModal",
    staticClass: "text-left",
    attrs: {
      "id": "mobileNumber",
      "hide-footer": "",
      "title": "Welcome to Livedemy!"
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Contact no")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter contact no",
      "aria-describedby": "text"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('b-btn', {
    staticClass: "btn-large login-btn",
    attrs: {
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": function($event) {
        _vm.enrollGoogleUser()
      }
    }
  }, [_vm._v("Submit")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "registrationInfoModal",
    staticClass: "text-left",
    attrs: {
      "id": "registrationInfo",
      "hide-footer": "",
      "title": "Welcome to Livedemy!"
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [(_vm.showContact) ? _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Contact no")]) : _vm._e(), _vm._v(" "), (_vm.showContact) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thirdPartyUserObj.mobile),
      expression: "thirdPartyUserObj.mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter contact no",
      "aria-describedby": "text"
    },
    domProps: {
      "value": (_vm.thirdPartyUserObj.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thirdPartyUserObj.mobile = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showEmail) ? _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Email address")]) : _vm._e(), _vm._v(" "), (_vm.showEmail) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thirdPartyUserObj.email),
      expression: "thirdPartyUserObj.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter email address",
      "aria-describedby": "text"
    },
    domProps: {
      "value": (_vm.thirdPartyUserObj.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thirdPartyUserObj.email = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('b-btn', {
    staticClass: "btn-large",
    attrs: {
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": function($event) {
        _vm.enrollThirdPartyUser()
      }
    }
  }, [_vm._v("Submit")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "askCredentialModal",
    staticClass: "text-left",
    attrs: {
      "id": "askCredential",
      "hide-footer": "",
      "title": "Hey, user we do not have any contact details associated with user. Please enter contact details"
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [(!_vm.isContactDetailsOtpSend) ? _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Mobile number")]) : _vm._e(), _vm._v(" "), (!_vm.isContactDetailsOtpSend) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userEnteredValue),
      expression: "userEnteredValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter mobile number",
      "aria-describedby": "text"
    },
    domProps: {
      "value": (_vm.userEnteredValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userEnteredValue = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isContactDetailsOtpSend) ? _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("OTP")]) : _vm._e(), _vm._v(" "), (_vm.isContactDetailsOtpSend) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otpInput),
      expression: "otpInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Enter OTP",
      "aria-describedby": "text"
    },
    domProps: {
      "value": (_vm.otpInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otpInput = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), (!_vm.isContactDetailsOtpSend) ? _c('b-btn', {
    staticClass: "btn-large",
    attrs: {
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": function($event) {
        _vm.checkContactDetails()
      }
    }
  }, [_vm._v("Send OTP")]) : _vm._e(), _vm._v(" "), (_vm.isContactDetailsOtpSend) ? _c('b-btn', {
    staticClass: "btn-large",
    attrs: {
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": function($event) {
        _vm.contactDetailsOtpVerification()
      }
    }
  }, [_vm._v("Verify OTP")]) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    ref: "otpVerificationForAccountLinkingModal",
    staticClass: "text-left",
    attrs: {
      "id": "otpVerificationForAccountLinking",
      "hide-footer": "",
      "title": "Hey, user we do not have any contact details associated with user. Please enter contact details"
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("OTP ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userEnteredValue),
      expression: "userEnteredValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter OTP",
      "aria-describedby": "text"
    },
    domProps: {
      "value": (_vm.userEnteredValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userEnteredValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('b-btn', {
    staticClass: "btn-large",
    attrs: {
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": function($event) {
        _vm.verifyOtp(_vm.userEnteredValue)
      }
    }
  }, [_vm._v("Send OTP")])], 1)], 1)])], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a31c895","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/headerLogin.vue
// module id = Ze7p
// module chunks = 1